import axios from 'axios'
import extractApiData from 'Helpers/extractApiData'
import { encodeParams } from 'mailup-react-helpers'

const endpoints = (baseURL => {
  return {
    getHTMLFromStructure: isPreview =>
      `${baseURL}/api/v2/nlparser?${encodeParams({ isPreview })}`
  }
})(process.env.BEE_PARSER_URL)

export const beeParserApiGetHTMLFromStructure = (
  token,
  jsonStructure,
  isPreview = false
) => {
  const url = endpoints.getHTMLFromStructure(isPreview)

  return axios({
    url,
    method: 'post',
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
      Authorization: `Bearer ${token}`
    },
    data: jsonStructure
  }).then(extractApiData)
}
